import { HelpCircle } from 'lucide-react';
import type { ReactNode } from 'react';

import { Button } from '~/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '~/components/ui/popover';

/**
 * A (?) beside a page title that opens a short explanation on click (and with
 * the keyboard) — where the "how this works" banners used to sit at the top of
 * every page. Help is there for whoever wants it, out of the way for everyone else.
 */
export function PageHelp({ label, children }: { label: string; children: ReactNode }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-label={label}
          className="text-muted-foreground hover:text-foreground size-8 cursor-pointer rounded-full"
        >
          <HelpCircle aria-hidden="true" className="size-[18px]" />
        </Button>
      </PopoverTrigger>
      {/* Never taller than the room on screen: a long legend scrolls inside instead of
          running off the top or bottom when there is little space around the (?). */}
      <PopoverContent
        align="start"
        collisionPadding={12}
        className="text-muted-foreground flex max-h-[var(--radix-popover-content-available-height)] w-80 flex-col gap-2 overflow-y-auto text-sm leading-relaxed"
      >
        {children}
      </PopoverContent>
    </Popover>
  );
}
